$(document).ready(function () {

    $('a.mm-navbar__title, a.mm-hidden').attr('href', '#')
    $('.header-1 a').each( function(){
        $(this).append('<span class="sr-only">' + $(this).attr('title') + '</span>')
    });

    /* Display Breite */
    var screen = $(window)

    /* Logo bei resonsive Viewports ändern */
    if(screen.width() < 1024 ) {
        $('.logo').attr('src', '/typo3conf/ext/hg_KOCHS/Resources/Public/img/logo-footer.png');
        $('header').css('min-height', '80px');
        $('.border-left').each(function() {
            $(this).addClass('border-top').removeClass('border-left');
        });
    }

    /* Bei Klick außerhalb des geöffneten Menüs, schließe Menü */
    if (screen.width() > 768) {
        $('main').click( function () {
            if ($('header').hasClass('opened')) {
                $('.nav-toggler span').text('Menu')
                $('.hamburger').removeClass('open');
                $('body').removeClass('overflow-hidden');
                $('header').toggleClass('opened');
                $('main').toggleClass('content-overlay');
            }
        })
    }

    /* Logo beim scrollen wechseln */
    /*$(window).scroll(function () {
        if ($(document).scrollTop() > 50 ) {
            if ($('.logo').attr('src').indexOf('small') === -1) {
                $('.logo').fadeOut(300, function () {
                    $('.logo').attr('src', '/typo3conf/ext/hg_KOCHS/Resources/Public/img/logo-footer.png');
                    $('.logo').fadeIn(150)
                })
                //$('header').css('min-height', '80px');
            }

        } else {
            if($(window).width() >= 1024) {
                if ($('.logo').attr('src').indexOf('small') !== -1) {
                    $('.logo').fadeOut(300, function () {
                        $('.logo').attr('src', '/typo3conf/ext/hg_KOCHS/Resources/Public/img/logo-footer.png');
                        $('.logo').fadeIn(150)
                    })
                    //$('header').css('min-height', '143px');
                }
            }
        }
    });*/

    /* Tab Navigation */
    $('.nav-pills a:first').addClass('active');
    $('.tab-content .tab-pane:first').addClass('show active');

    /* HEADER-MENU ONLY START  */
    /* Subnavigation öffnen und schließen */
    $('.header-main .nav.text-center .nav-link').click (
        function () {
        /* Fix clickable HEADER-NAV */    
        if ($('header').hasClass('opened')) {
            $('.nav-toggler span').text('Menu')
            $('.hamburger').addClass('open');
            $('body').addClass('overflow-hidden');
            $('header').addClass('opened');
            $('main').addClass('content-overlay');
        }


        /* Wenn es sich um eine Subnavi Column handelt */
        if(!$(this).parents().eq(0).hasClass('sub-nav-col')) {
            // Get Data to know which menu to open
            var linkdata2 = $(this).data("menu")
            if (!linkdata2) {
                $('.sub-nav-col').css("display", "none");
            } /*else {
                linkdata2.addClass('text-secondary')
            }*/
            // Hide all menus
            $('.sub-nav-col').css("display", "none");
            // Display target menu
            $('.sub-nav-col[data-menu="' + linkdata2 + '"]').css("display", "block");
            //$('.sub-nav-col[data-menu="' + linkdata2 + '"]').addClass("active");

            /*if(Number.isInteger($(this).data('menu'))) {
                var links = $("a[data-menu*=" + $(this).data('menu') + "]");
                for (var i = 0; i < links.length; i++) {
                    $(links[i]).toggleClass('text-secondary')
                }
            }*/
        }
    },
    /*function () {
        if(Number.isInteger($(this).data('menu'))) {
            var links = $("a[data-menu*=" + $(this).data('menu') + "]");
            for (var i = 0; i < links.length; i++) {
                $(links[i]).removeClass('active')
            }
        }

        
    }*/);
        
/* HEADER-MENU ONLY END  */
   


    /* Subnavigation öffnen und schließen */
    $('.header-main .nav.flex-column .nav-link').hover(
        function () {

        /* Wenn es sich um eine Subnavi Column handelt */
        if(!$(this).parents().eq(2).hasClass('sub-nav-col')) {
            // Get Data to know which menu to open
            var linkdata = $(this).data("menu")
            if (!linkdata) {
                $('.sub-nav-col').css("display", "none");
                return
            }
            // Hide all menus
            $('.sub-nav-col').css("display", "none");
            // Display target menu
            $('.sub-nav-col[data-menu="' + linkdata + '"]').css("display", "block");
        } else {
            /* Bei Mouse-over einer App-Seite, zugehörige Produkte hervorheben */
            

            if(Number.isInteger($(this).data('application'))) {
                var links = $("a[data-applications*=" + $(this).data('application') + "]");
                for (var i = 0; i < links.length; i++) {
                    $(links[i]).addClass('text-secondary')
                }
            }
            /* Bei Mouse-over einer Produkt-Seite, zugehörige Apps hervorheben */
            if( typeof $(this).data('applications') == "string" ) {
                if ($(this).data('applications').indexOf(',') > -1) {
                    var apps = $(this).data('applications').split(',')
                    for (var i = 0; i < apps.length; i++) {
                        $("a[data-application=" + apps[i] + "]").addClass('text-secondary')
                    }
                }
            }else {
                $("a[data-application=" + $(this).data('applications') + "]").addClass('text-secondary')
            }
        }
    },
        function () {
            /*if(Number.isInteger($(this).data('menu'))) {
                var links = $("a[data-menu*=" + $(this).data('menu') + "]");
                for (var i = 0; i < links.length; i++) {
                    $(links[i]).removeClass('text-secondary')
                }
            }*/

            /* Hervorheben zurücksetzen bei Mouse-out */
            if(Number.isInteger($(this).data('application')) && $(this).parents().eq(2).hasClass('sub-nav-col')) {
                var links = $("a[data-applications*=" + $(this).data('application') + "]");
                for (var i = 0; i < links.length; i++) {
                    $(links[i]).removeClass('text-secondary')
                }
            }
            /* Bei Mouse-over einer Produkt-Seite, zugehörige Apps hervorheben */
            if( typeof $(this).data('applications') == "string" ) {
                if ($(this).data('applications').indexOf(',') > -1) {
                    var apps = $(this).data('applications').split(',')
                    for (var i = 0; i < apps.length; i++) {
                        $("a[data-application=" + apps[i] + "]").removeClass('text-secondary')
                    }
                }
            }else {
                $("a[data-application=" + $(this).data('applications') + "]").removeClass('text-secondary')
            }
        });

    

    /* Toggle Menu-Button Text & Animation */
    $('.nav-toggler, .mm-btn_close').click(function () {
        if($(window).width() >= 768 ) {
            $('header').toggleClass('opened');
            $('body').toggleClass('overflow-hidden');
            $('main').toggleClass('content-overlay');
            //$('body').toggleClass('overflow-hidden');
            if ($('header').hasClass('opened')) {
                $('.nav-toggler span').text('Close')
                $('.hamburger').addClass('open');
            } else {
                $('.nav-toggler span').text('Menu')
                $('.hamburger').removeClass('open');
            }
        }
    });
    /* Toggle Menu-Button Text & Animation */
    $('.nav-toggler2, .mm-btn_close').click(function () {
        if($(window).width() >= 768 ) {
            $('header').addClass('opened');
            $('body').addClass('overflow-hidden');
            $('main').addClass('content-overlay');
            //$('body').toggleClass('overflow-hidden');
            if ($('header').hasClass('opened')) {
                $('.nav-toggler span').text('Close')
                $('.hamburger').addClass('open');
            } else {
                $('.nav-toggler span').text('Menu')
                $('.hamburger').removeClass('open');
            }
        }
    });

    var $div = $('.mm-listview');
    $div.after($('#header-mobile .dropdown').css('padding-left', '20px'));
});

/* Initialize mobile Menu */
document.addEventListener(
    "DOMContentLoaded", () => {
        const menu = new Mmenu("#my-menu", {
            // options
            "extensions": [
                "position-top",
                "multiline",
                "border-none",
                "shadow-panels",
                "fullscreen"
            ],
            "navbar": false,
            "setSelected": {
                "current": true,
                "hover": true,
                "parent": true
            },
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        'prev',
                        "<img style='height: 40px; padding: .25rem 0;' src='/typo3conf/ext/hg_KOCHS/Resources/Public/img/logo-footer.png' />",
                        'close'
                    ]
                },
                {
                    "position": "bottom",
                    "content": [
                      '<a class="navbar-brand " href="/de/impressum">Impressum</a>',    
                  ]
                },
                {
                    "position": "bottom",
                    "content": [
                      '<a class="navbar-brand mr-auto" href="/de/datenschutz">Datenschutz</a>',         
                  ]
                },
                {
                    "position": "bottom",
                    "content": [
                      '<div><a href="https://facebook.com" class="icon socicon socicon-linkedin  text-white pr-3" target="_blank" alt="Facebook" aria-label="Facebook"><i class="fab fa-facebook"></i></a><a href="" class="icon socicon socicon-linkedin  text-white pr-3" target="_blank" alt="Instagram" aria-label="Instagram"><i class="fab fa-instagram"></i></a><a href="" class="icon socicon socicon-linkedin  text-white pr-3" target="_blank" alt="Linkedin" aria-label="Linkedin"><i class="fab fa-linkedin-in"></i></a><a href="" class="icon socicon socicon-xing   text-white pr-3" target="_blank" alt="Xing" aria-label="Xing"><i class="fab fa-xing"></i></a><a href="" class="icon socicon socicon-xing   text-white" target="_blank" alt="Xing" aria-label="Xing"><i class="fab fa-youtube"></i></a></div>',
                  ]
                }
            ],
        }, {
            // configuration
            classNames: {
                fixedElements: {
                    fixed: "fix"
                }
            }
        })
        const api = menu.API;

        document.querySelector("#menu-btn")
            .addEventListener(
                "click", (evnt) => {
                    evnt.preventDefault();

                    if($('#my-menu').hasClass('mm-menu_opened')) {
                        // Invoke a method
                        api.close();
                        console.log('close')
                    } else {
                        log('open')
                        api.open();
                    }
                }
            );

        var nextBtns = document.querySelectorAll(".mm-btn_next");
        nextBtns.forEach(function (nextBtn) {
                nextBtn.addEventListener(
                    "click", (evnt) => {

                        $('#menu-btn').addClass('d-none')
                        $('#back-btn').removeClass('d-none')
                    }
                );
        })
        document.querySelector("#back-btn")
            .addEventListener(
                "click", (evnt) => {

                    // Invoke a method
                    const panel = document.querySelector( "#mm-0" );
                    api.openPanel( panel );
                    console.log('back')
                    $('#menu-btn').removeClass('d-none')
                    $('#back-btn').addClass('d-none')
                }
            );
    }
);



// WEBPACK FOOTER //
// ./js/global/navi.js